/**
 * Zod transform function for nullable text fields.
 *
 * - Trims leading and trailing whitespace from a string
 * - Converts empty strings to null
 * - Returns null if the input is not a string (e.g., already null)
 *
 * Useful for optional form fields where whitespace-only input should be treated as empty.
 */
export const trimAndNullifyEmpty = (val: unknown): string | null => {
  if (typeof val !== 'string') return null
  return val.trim() || null
}

/**
 * Zod transform function for nullable text fields.
 *
 * - Returns the original string if provided
 * - Converts null to an empty string
 */
export const nullToEmptyString = (val: string | null): string => {
  return val === null ? '' : val
}
